import axios from 'axios';

// Detect Tauri Desktop environment
const isTauri = typeof window !== 'undefined' && (
  window.__TAURI_IPC__ !== undefined ||
  window.__TAURI__ !== undefined ||
  (window.location && window.location.protocol === 'tauri:')
);

// Backend URL priority:
// 1. REACT_APP_BACKEND_URL env (e.g., production cloud URL) — preferred
// 2. Local sidecar at 127.0.0.1:8001 when in Tauri without env
// 3. Empty (errors)
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = ENV_URL && ENV_URL.trim()
  ? ENV_URL.trim()
  : (isTauri ? 'http://127.0.0.1:8001' : '');

export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
